import React, { useEffect, useState } from "react";
import arrowBack from "../../Asserts/images/arrow_back.svg";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { baseURL } from "../../services/axiosConfig";
import { refreshTokenV2 } from "../../services/api";

const CircularLoader = () => (
  <div className="flex flex-col items-center justify-center py-8">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
    <div className="text-blue-500 font-medium">Data fetching...</div>
  </div>
);

const top5Color = [
  {
    background: "#2C5626",

    text: "#fff",
  },
  {
    background: "#00FF86",
    text: "#000",
  },
  {
    background: "#FFD600",
    text: "#000",
  },
  {
    background: "#F1003A",
    text: "#fff",
  },
  {
    background: "#8F0025",
    text: "#fff",
  },
];

function PickSummary({
  pickDetails,
  potId,
  seasonId,
  pickId,
  currentMatchWeek,
  matchWeeksId,
  matchWeeks,
}) {
  const dispatch = useDispatch();
  const token = localStorage.getItem("access_token");
  const [allMatchWeek, setAllMatchWeek] = useState([]);
  const [matchWeek, setMatchWeek] = useState(Number(currentMatchWeek) || 1);
  const [pickSummary, setPickSummary] = useState([]);
  const pickDetailMatchWeek = useSelector(
    (state) => state.roundToJoin.pickDetailMatchWeek
  );

  const [isPickSumaryLoading, setIsPickSumaryLoading] = useState(false);

  async function fetchAllMatchWeek() {
    try {
      setIsPickSumaryLoading(true);
      const token = localStorage.getItem("access_token");
      const res = await axios.get(
        `${baseURL}/pot/seasonmatchweeks?season=${seasonId}&pot_id=${potId}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );
      setIsPickSumaryLoading(false);
      setAllMatchWeek(res.data.data);
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      setIsPickSumaryLoading(false);
      console.log(error);
    }
  }

  async function fetchPickSummary() {
    try {
      const findMatchWeek =
        allMatchWeek?.find((ele) => {
          return ele.matchweek_number === matchWeek;
        })?.id || matchWeeks;
      const res = await axios.get(
        `${baseURL}/pot/picksummary?pot=${potId}&matchweek=${findMatchWeek}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );
      setPickSummary(res.data);
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
    }
  }

  useEffect(() => {
    fetchPickSummary();
  }, [currentMatchWeek, matchWeek]);

  useEffect(() => {
    fetchAllMatchWeek();
  }, [seasonId, matchWeek]);

  // Calculate min and max match week values
  const minWeek = allMatchWeek?.length
    ? Math.min(
        ...allMatchWeek.map(
          (m) =>
            Number(m.matchweek_number) || Number(m.matchweek_number?.charAt(0))
        )
      )
    : 1;

  const maxWeek = allMatchWeek?.length
    ? Math.max(
        ...allMatchWeek.map(
          (m) =>
            Number(m.matchweek_number) || Number(m.matchweek_number?.charAt(0))
        )
      )
    : 1;

  return (
    <div className="w-full lg:w-1/3 xl:h-[700px] md:h-[600px] bg-[#D0E8FF] flex flex-col rounded-[12px] border border-gray-200 h-screen pb-4">
      {/* Header */}
      <div className="p-4 border-b-4 border-black bg-white text-center rounded-tl-[12px] rounded-tr-[12px] flex-shrink-0">
        <h2 className="text-lg font-semibold font-archivo">Pick Summary</h2>
        <p className="text-sm text-gray-600 font-archivo">
          Top 5 picks of the Match week
        </p>
      </div>
      {isPickSumaryLoading ? (
        <CircularLoader />
      ) : (
        <>
          {/* Mid Section */}

          <div className="p-4 bg-[#009FAE] flex items-center justify-between text-white flex-shrink-0">
            <img
              src={arrowBack}
              className={`h-5 w-5 sm:h-6 sm:w-6 cursor-pointer ${
                matchWeek <= minWeek
                  ? "opacity-50 pointer-events-none cursor-not-allowed"
                  : ""
              }`}
              alt="Previous"
              onClick={() => {
                if (matchWeek > minWeek) {
                  setMatchWeek((prev) => prev - 1);
                }
              }}
            />
            <p className="text-base sm:text-lg font-semibold font-archivo">
              Match Week {matchWeek}
            </p>
            <img
              src={arrowBack}
              className={`h-5 w-5 sm:h-6 sm:w-6 rotate-180 cursor-pointer ${
                matchWeek >= maxWeek
                  ? "opacity-50 pointer-events-none cursor-not-allowed"
                  : ""
              }`}
              alt="Next"
              onClick={() => {
                if (matchWeek < maxWeek) {
                  setMatchWeek((prev) => prev + 1);
                }
              }}
            />
          </div>

          {pickSummary?.data?.top_5?.length === 0 &&
          pickSummary?.data?.others === 0 ? (
            <div className="text-center text-gray-400 pt-8">
              No fixtures available
            </div>
          ) : (
            <div className="flex-grow overflow-auto w-[95%] sm:w-[90%] mx-auto rounded-lg border bg-white px-2 sm:px-6 mt-4">
              {pickSummary?.data?.top_5?.map((fixture, index) => {
                const isLast = index === pickSummary.data.top_5.others - 1;
                const isIpadHorizontal = window.innerWidth >= 820 && window.innerWidth <= 1180;
                return (
                  <div
                    key={index}
                    className={`flex items-center justify-between mb-3 p-2 
        ${!isLast ? "border-b border-b-[#37003C1F]" : ""}`}
                  >
                    <div className={`flex items-center ${isIpadHorizontal ? "gap-2" : "gap-2 sm:gap-4 lg:gap-3"}`}>
                      <img
                        src={fixture.logo}
                        alt={`${fixture.name} logo`}
                        className="h-8 w-8 sm:h-8 sm:w-8 md:h-10 md:w-10"
                      />
                      <p className="text-xs sm:text-sm text-[#00000080] font-semibold font-archivo">
                        {fixture.name.slice(0, 3).toUpperCase()}
                      </p>
                    </div>
                    <div className={`flex items-center ${isIpadHorizontal ? "gap-2" : "gap-2 sm:gap-6 lg:gap-16"}`}>
                      <p
                        style={{
                          padding: "2px 4px",
                          borderRadius: "4px",
                          background: top5Color[index].background,
                          color: top5Color[index].text,
                          fontSize: window.innerWidth < 375 ? "12px" : "16px",
                          minWidth: "26px",
                          textAlign: "center",
                        }}
                      >
                        {fixture.prediction_count}
                      </p>
                      <p
                        className={`border-2 border-gray-500 bg-[#F5F2F580] font-archivo text-[#37003C99] rounded whitespace-nowrap ${
                          isIpadHorizontal ? "px-1.5 py-0.5 text-[10px]" : "px-1 sm:px-2 py-0.5 sm:py-1 text-sm sm:text-sm"
                        } ${
                          fixture.default_prediction_count > 0
                            ? ""
                            : "invisible"
                        }`}
                      >
                        {fixture.default_prediction_count} Default Pick
                      </p>
                    </div>
                  </div>
                );
              })}
              {pickSummary?.data?.others?.map((fixture, index) => {
                const isLast = index === pickSummary.data.others.length - 1;
                const isIpadHorizontal = window.innerWidth >= 820 && window.innerWidth <= 1180;
                return (
                  <div
                    key={index}
                    className={`flex items-center justify-between mb-3 p-2 
        ${!isLast ? "border-b border-b-[#37003C1F]" : ""}`}
                  >
                    <div className={`flex items-center ${isIpadHorizontal ? "gap-2" : "gap-2 sm:gap-4 lg:gap-3"}`}>
                      <img
                        src={fixture.logo}
                        alt={`${fixture.name} logo`}
                        className="h-8 w-8 sm:h-8 sm:w-8 md:h-10 md:w-10"
                      />
                      <p className="text-xs sm:text-sm text-[#00000080] font-semibold font-archivo">
                        {fixture.name.slice(0, 3).toUpperCase()}
                      </p>
                    </div>
                    <div className={`flex items-center ${isIpadHorizontal ? "gap-2" : "gap-2 sm:gap-6 lg:gap-16"}`}>
                      <p
                        style={{
                          padding: "2px 4px",
                          borderRadius: "4px",
                          background: "#00000033",
                          color: "#000000",
                          fontSize: window.innerWidth < 375 ? "12px" : "16px",
                          minWidth: "26px",
                          textAlign: "center",
                        }}
                      >
                        {fixture.prediction_count}
                      </p>
                      <p
                        className={`border-2 border-gray-500 bg-[#F5F2F580] font-archivo text-[#37003C99] rounded whitespace-nowrap ${
                          isIpadHorizontal ? "px-1.5 py-0.5 text-[10px]" : "px-1 sm:px-2 py-0.5 sm:py-1 text-sm sm:text-sm"
                        } ${
                          fixture.default_prediction_count > 0
                            ? ""
                            : "invisible"
                        }`}
                      >
                        {fixture.default_prediction_count} Default Pick
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Fixture list */}
        </>
      )}
    </div>
  );
}

export default PickSummary;
